<template>
  <div class="header-navigation-left">
    <div class="navigation">
      <!-- <div class="flex items-center p-4">
      <img
        class="cursor-pointer"
        :src="logoIcon.src"
        :width="logoIcon.width"
        :height="logoIcon.height"
        @click="onClickLayout"
      >
    </div> -->
      <app-header-navigation-item
        v-for="(menuItem, idx) in menuItems"
        :key="idx"
        :menu-item="menuItem"
        :visible="visible"
      />
    </div>

    <!-- phần info -->
    <div
      class="navigation-info"
      v-if="isStudent && menuItemsMoreInfo.length > 0"
    >
      <ms-popover
        placement="bottom"
        v-model:visible="visible"
      >
        <app-header-navigation-item
          v-for="(menuItemInfo, idx) in menuItemsMoreInfo"
          :key="idx"
          class="menu-item-height"
          :active="active"
          :menu-item="menuItemInfo"
          @click="clickItem"
        />
        <template #reference>
          <div
            @click="visible = true"
            class="menu-item"
            :class="activeClass"
          >
            <img :src="moreIcon">
            <div class="item-text">
              {{ $t('Navigation.MoreOption') }}
            </div>
          </div>
        </template>
      </ms-popover>
    </div>
  </div>
</template>

<script>
import AppHeaderNavigationItem from './app-header-navigation-item.vue'
import MsPopover from '@/components/popover'
import { UserType } from '@/common/constant'
import { getContextData, ContextDataKey } from '@/utils/context-data'

export default {
  components: { AppHeaderNavigationItem, MsPopover },

  name: 'AppHeaderNavigation',

  props: {
    menuItems: {
      type: Array,
      required: true
    },
    menuItemsMoreInfo: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      visible: false,
      moreIcon: require('@/assets/icons/svg/navbar/ic_More_24.svg'),
      logoIcon: {
        src: require('@/assets/icons/svg/logo/logo_login.svg'),
        width: 40,
        height: 35
      }
    }
  },

  computed: {
    activeClass () {
      return this.visible || this.active ? 'active-class' : null
    },

    isStudent () {
      return getContextData(ContextDataKey.UserType) === UserType.Student
    },
    active () {
      return !!this.menuItemsMoreInfo.find(
        (x) => x.path === this.$route.matched[1]?.path
      )
    }
  },

  methods: {
    clickItem () {
      this.visible = false
    },

    /**
     * Click cho Logo
     */
    onClickLayout () {
      const me = this

      if (me.$route.meta.isExam) {
        me.$router.push('/teacher/exam-period')
      } else if (me.$route.meta.isEventCalendar) {
        me.$router.push('/teacher/list-calendar')
      } else {
        me.$router.push('/teacher/dashboard')
      }
      if (me.isStudent) {
        me.$router.push('/student/dashboard')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-navigation-left {
  height: 100%;
  width: auto;
  display: flex;
  align-items: center;
}

.navigation {
  height: 100%;
  width: auto;
  display: flex;
  align-items: center;
}
.navigation-info {
  height: 100%;
  width: auto;
  align-items: center;

  .menu-item {
    height: 100%;
    padding: 0 12px;
    margin: 0 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: $color-neutral-light-4;
    text-decoration: none;

    img {
      margin-right: 8px;
      filter: invert(32%) sepia(26%) saturate(344%) hue-rotate(171deg) brightness(100%) contrast(91%);
    }

    .item-text {
      min-width: fit-content;
    }
  }

  .active-class {
    border-bottom: 2px solid $color-accent;
    font-weight: 700;
    color: $color-accent;

    img {
      filter: invert(69%) sepia(72%) saturate(6261%) hue-rotate(227deg) brightness(99%) contrast(94%);
    }
  }
}

.menu-item-height {
  padding: 8px 8px;
  margin: 0;
}
</style>
